import { render, staticRenderFns } from "./ValidFaturamento.vue?vue&type=template&id=0f34c5a0&"
import script from "./ValidFaturamento.vue?vue&type=script&lang=js&"
export * from "./ValidFaturamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports